import React, { useState } from 'react';
import { Form, Input, Image, Button, Col, Row, Divider } from 'antd';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';

import { sendData } from '../../httpRequests';

import logo from '../../assets/images/logo_coopharma.png';
import './auth.css';

const Register = () => {
	let navigate = useNavigate();
	const [isLoading, setIsLoading] = useState(false);

	const register = (values) => {
		setIsLoading(true);

		const url = '/pharmacies/createNewPharmacy';
		const data = {
			pharmacy_name: values.name,
			add_1: values.address,
			phone: values.phone,
			email: values.email,
			password: values.password,
			city: values.city,
			zip: values.zip,
			npi: '',
			secret_key: ''
		};

		sendData(url, data).then((response) => {
			if (Object.keys(response).length > 0) {
				setTimeout(() => {
					setIsLoading(false);
					Swal.fire({
						text: response['message'],
						icon: 'success',
						confirmButtonColor: '#128780'
					}).then(() => {
						navigate('/login', { replace: true });
					});
				}, 1500);
			} else {
				Swal.fire({
					text: '',
					icon: 'error'
				});
			}
		});
	};

	return (
		<div className='container'>
			<div className='auth-header'>
				<Image src={logo} className='logo' preview={false} height={100} width={280} />
				<h1 className='title'>Join us!</h1>
			</div>
			<Form layout='vertical' className='form' onFinish={register}>
				<Row gutter={24}>
					<Col span={12}>
						<Form.Item
							label='Email'
							name='email'
							rules={[
								{
									required: true
								}
							]}
						>
							<Input size='large' type='email' autoCapitalize='false' />
						</Form.Item>
					</Col>
					<Col span={12}>
						<Form.Item
							label='Password'
							name='password'
							rules={[
								{
									required: true
								}
							]}
						>
							<Input.Password size='large' />
						</Form.Item>
					</Col>
				</Row>
				<Row gutter={24}>
					<Col span={12}>
						<Form.Item
							label='Pharmacy Name'
							name='name'
							rules={[
								{
									required: true
								}
							]}
						>
							<Input size='large' type='text' />
						</Form.Item>
					</Col>
					<Col span={12}>
						<Form.Item
							label='Phone Number'
							name='phone'
							rules={[
								{
									required: true
								}
							]}
						>
							<Input size='large' type='tel' />
						</Form.Item>
					</Col>
				</Row>
				<Row>
					<Col span={24}>
						<Form.Item
							label='Address'
							name='address'
							rules={[
								{
									required: true
								}
							]}
						>
							<Input size='large' type='text' />
						</Form.Item>
					</Col>
				</Row>
				<Row gutter={24}>
					<Col span={12}>
						<Form.Item
							label='City'
							name='city'
							rules={[
								{
									required: true
								}
							]}
						>
							<Input size='large' type='text' />
						</Form.Item>
					</Col>
					<Col span={12}>
						<Form.Item
							label='Zip code'
							name='zip'
							rules={[
								{
									required: true
								}
							]}
						>
							<Input size='large' type='text' />
						</Form.Item>
					</Col>
				</Row>
				<Divider />
				<div className='formFooter'>
					<Button type='primary' htmlType='submit' loading={isLoading} disabled={isLoading}>
						Sign Up
					</Button>
					<span className='spanText'>
						Already have an account?{' '}
						<span
							className='spanTextLink'
							onClick={() => {
								window.location.href = '/login';
							}}
						>
							Sign in!
						</span>
					</span>
				</div>
			</Form>
		</div>
	);
};

export default Register;
